<template>
  <div class="table-box">
    <el-table ref="tableRef" :data="tableData" highlight-current-row :key="tableKey" class="tableClass">
      <template>
        <slot v-for="item in columnData">
          <!-- 性别 -->
          <el-table-column v-if="item.name=='sex'" :render-header="renderHeader" prop="sex" :label="item.cnName">
            <template slot-scope="scope">{{ Language(scope.row.sex==1?'男':scope.row.sex==2?'女':'') }}</template>
          </el-table-column>
          <!-- 字段为是、否 -->
          <el-table-column v-else-if="columnList.includes(item.name)" :render-header="renderHeader" :prop="item.name" :label="item.cnName">
            <template slot-scope="scope">{{ Language(scope.row[item.name]==1?'是':scope.row[item.name]==0?'否':'') }}</template>
          </el-table-column>
          <!-- 会话标签-显示完整路径 -->
          <el-table-column v-else-if="item.name=='labMsg'" show-overflow-tooltip :render-header="renderHeader" :prop="item.name" :label="item.cnName">
            <template slot-scope="scope">{{ scope.row.labPath }}</template>
          </el-table-column>
          <!-- 客户、公司、部门、人员、工单类型、优先级、客户等级、创建人、工单状态 -->
          <el-table-column v-else-if="item.name=='cusId'||item.name=='cId'||item.name=='groupId'||item.name=='userId'||item.name=='orderTypeCode'||item.name=='priorityCode'||item.name=='levelCode'||item.name=='createOper'||item.name == 'status'" 
            show-overflow-tooltip :render-header="renderHeader" :prop="item.name" :label="item.cnName">
            <template slot-scope="scope">
              <span>{{formatColumn(item.name, scope.row)}}</span>
            </template>
          </el-table-column>
          <!-- 已配置数据字典的字段 -->
          <el-table-column v-else-if="item.dataOrigin&&item.dataOrigin!='0'" show-overflow-tooltip :render-header="renderHeader" :prop="item.name" :label="item.cnName">
            <template slot-scope="scope">
              <span>{{formatEmployment(item, scope.row[item.name])}}</span>
            </template>
          </el-table-column>
          <!-- 客户电话 -->
          <el-table-column v-else-if="(item.name=='telData'&&!GLOBAL.power.is_1030)||item.name=='vId'||item.name=='nikeName'" show-overflow-tooltip :render-header="renderHeader" :prop="item.name" :label="item.cnName"
           :formatter="formatterPhone"></el-table-column>
          <!-- 时间类型 datetimerange、date、time、datetime -->
          <el-table-column v-else-if="item.inputType=='datetimerange'||item.inputType=='date'||item.inputType=='time'||item.inputType=='datetime'" show-overflow-tooltip 
            :render-header="renderHeader" :prop="item.name" :label="item.cnName" width="160px"></el-table-column>
          <!-- 默认字段 -->
          <el-table-column v-else-if="item.name!='telData'" show-overflow-tooltip :render-header="renderHeader" :prop="item.name" :label="item.cnName"></el-table-column>
        </slot>
        <slot v-if="columnData.length > 0">
          <el-table-column :label="Language('操作')" fixed="right" width="120">
            <template slot-scope="scope" v-if="operationComponent.length > 0">
              <el-tooltip v-for="item in operationComponent" :key="item.id" :enterable="false" :content="item.content" placement="top">
                <span v-if="scope.row.status==8">
                  <el-button type="text" :icon="item.icon" :key="item.id" @click.native="opermethods(scope.$index, scope.row, item.function)" v-if="item.content=='查看'" 
                    style="padding: 0;"></el-button>
                </span>
                <span v-else>
                  <span v-if="scope.row.status">
                    <el-button type="text" :icon="item.icon" :key="item.id" @click.native="opermethods(scope.$index, scope.row, item.function)" v-if="scope.row.status==0&&item.content!='跟进'" 
                      style="padding: 0;"></el-button>
                    <el-button type="text" :icon="item.icon" :key="item.id" @click.native="opermethods(scope.$index, scope.row, item.function)" v-if="scope.row.status!=0&&item.content!='编辑'"
                      style="padding: 0;"></el-button>
                  </span>
                  <span v-else>
                    <el-button type="text" :icon="item.icon" :key="item.id" @click.native="opermethods(scope.$index, scope.row, item.function)"
                      style="padding: 0;"></el-button>
                  </span>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
        </slot>
      </template>
    </el-table>
    <el-tooltip class="item" effect="dark" content="表格设置" placement="top">
      <el-button type="text" class="btn_setting iconfont icon1peizhi" @click="setTable(true)"></el-button>
    </el-tooltip>

    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pageSize" :total="total" v-if="total>0"></el-pagination>

    <el-dialog :title="Language('表格设置')" :visible="searchSetVisible" :modal-append-to-body="false" :close-on-press-escape="false"
      :close-on-click-modal="false" top="10vh" width="600px" class="abow_dialog" @close="setTable(false)">
      <SearchSet @closedialogVosible="setTable" @getNewData="getNewData" :visibleAllTitle="searchSetVisible" :configType="configType" :formValue="formValue" :partType="partType"></SearchSet>
    </el-dialog>
  </div>
</template>

<script>
	import { getDictMap } from '@/http/BaseData.js'
	import { getListDict } from '@/http/DictManagement.js'
	import SearchSet from './SearchSet'
  import { getParentKey, formatTableData } from '@/utils/auth.js'

  export default {
    components: { SearchSet },
    props: {
      total: {// 分页数据总数
        type: Number, default: 0, required: false,
      },
      pageSize: {// 单页数据量
        type: Number, default: 10, required: false,
      },
      currentPage: {// 当前页码
        type: Number, default: 1, required: false,
      },
      tableData: {// 表格数据
        type: Array, default: () => [], required: false,
      },
      configType:{//表类型，1.客户 2.客户公司 3.工单
        type: Number, default: 1, required: true,
      },
      formValue:{//页面配置值 1.客户页面 2.公司页面 3.工单页面
        type: Number, default: 1, required: true,
      },
      columnData: {// 表头数据
        type: Array, default: () => [], required: true,
      },
      operationComponent: {
        type: Array, default: () => [], required: true,
      },
      partType: { //search: 搜索字段  column:列表显示字段 form：工单表单显示字段
        type: String, default: false, required: false,
      }
    },
    watch: {
      tableData: {
        deep: true,
        handler: function (newV, oldV) {
          this.$nextTick(() => {
            this.$refs.tableRef.doLayout()
          })
        },
      },
      columnData:{
        deep: true,
        immediate: true,
        handler: function (newV, oldV) {
          this.tableKey = !this.tableKey;
          if(newV.length>0){
            this.getDictyFilterData()
            this.fetchCascaderDicty()
            // this.getDictyFiltercascaderData();
          }
          
        }, 
      }
    },
    data() {
      return {
        optionList: {},
        tableKey: false,
        searchSetVisible: false,
        filterData: {},
        statusList: {
          0: '暂存', 1: '开启', 2: '已分配', 3: '处理中', 4: '已解决', 5: '回访中', 6: '待回访', 7: '已回访', 8: '关闭'
        },
        vdnId:  JSON.parse(LocalStorage.getItem('obj')).vdnId,
        columnList: ['isOverTime', 'isWheelOverTime', 'isTipsCus', 'isVisit', 'isBeVisit', 'isSolved', 'isSat'],
      };
    },
    mounted() {
      this.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
    },
    methods: {
      //格式化电话
      formatterPhone(row, column ,val){
        let phones = val?val.split(','):[], newPhones = [], returnStr = ''
        if (column.property == 'vId' || column.property == 'nikeName') {
          if (row.originType == 'callcenter') {
            if (this.GLOBAL.power.is_1031) {//号码替换
              phones.map(item => {
                newPhones.push(this.hidePhoneNum(item))
              })
              returnStr = newPhones.join(',')
            } else returnStr = val
          } else returnStr = val
        } else {
          if (this.GLOBAL.power.is_1031) {//号码替换
            phones.map(item => {
              newPhones.push(this.hidePhoneNum(item))
            })
            returnStr = newPhones.join(',')
          } else returnStr = val
        }
        return returnStr
      },
      formatColumn(name, row) {
        return formatTableData(name, row)
      },
      formatEmployment(item, cellValue){//行数据对象，列属性对象，单元格数据，索引
        if (item.inputType =='select') {
          if(this.filterData[item.dataOrigin]){
            if(item.selectType == 2){//多选数据
              let afcellValue = cellValue.split(',')
              let newcellValue = [];
              for(let i=0;i<afcellValue.length;i++){
                const obj = this.filterData[item.dataOrigin].find(itemFit => itemFit.dictCode == afcellValue[i])
                if(obj){
                  newcellValue.push(obj.dictName) 
                }
              }
              return newcellValue.join(',')
            }else{//单选
              const obj = this.filterData[item.dataOrigin].find(itemFit => itemFit.dictCode == cellValue)
              if(obj){
                return obj.dictName
              }else{
                return  cellValue
              }
            }
          }
        } else if(item.inputType =='cascader'){
          if(this.filterData[item.dataOrigin]){
            let arr  = cellValue.split(',')
            let lastId = arr[arr.length-1]
            const resList = getParentKey(this.filterData[item.dataOrigin], lastId)
            if(resList.nameList.length>0){
              return resList.nameList.join('/');
            }else{
              return cellValue
            }
            
          }
        }
      },
      fetchCascaderDicty() {
        let paramsSelectData = this.columnData.filter(item=>{
          if( item.inputType == "cascader" && item.dataOrigin && item.dataOrigin!='0') {
            return item
          }
        })
        let selectParams =  paramsSelectData.map(item=>{ return item.dataOrigin })
        let selectParamsony = Array.from(new Set(selectParams))//去重
        if (selectParamsony.length) {
          selectParamsony.map(item => {
            let params ={
              dictTypeCode: item,
              vdnId:  JSON.parse(LocalStorage.getItem('obj')).vdnId
            }
            getListDict(params).then((res)=>{
              if(res && res.retCode == 1){
                this.filterData[item] = res.data
              }
            })
          })
        }
      },
      getDictyFilterData(){
        let paramsSelectData = this.columnData.filter(item=>{
          if( item.dataOrigin && item.dataOrigin!='0') return item
        })
        let selectParams =  paramsSelectData.map(item=>{ return item.dataOrigin })
        let selectParamsony = Array.from(new Set(selectParams))//去重
        if (selectParamsony.length) {
          let params = {
            dictTypeCodeList: selectParamsony,
            vdnId: this.vdnId
          }
          getDictMap(params).then((res)=>{ 
            if(res && res.retCode == 1){
              this.filterData = res.data
            }
          })
        }
      },
      handleCurrentChange(currentPage) {
        this.$emit("handleChange", this.pageSize, currentPage)
      },
      handleSizeChange(pageSize) {
        this.$emit("handleChange", pageSize, this.currentPage)
      },
      //表格设置
      setTable(status) {
        this.searchSetVisible = status
      },
      opermethods(index, data, methods) {
        this.$parent[methods](index, data)
      },
      getNewData(){
				this.$emit('fetchFormShowList')
      },
      //设置表头宽度适应
      renderHeader(h, { column, $index }) {
        let realWidth = 0;
        let span = document.createElement('span');
        span.innerText = column.label;
        document.body.appendChild(span);
        realWidth = span.getBoundingClientRect().width+60;
        column.minWidth = realWidth;
        document.body.removeChild(span);
        return h('span', column.label);
      }
    },
  };
</script>

<style lang="scss" scoped>
.table-box {
  position: relative;

  .btn_setting {
    position: absolute;
    right: 10px;
    top: -2px;
    z-index: 9;
    font-size: 18px;
  }
}

.tableButtons {
  float: right;
  margin-top: 20px;
}

.pagination {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 0px;
}

.tableClass /deep/.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tableClass /deep/.el-checkbox__input {
    cursor: pointer;
    outline: 0;
    line-height: 1;
    vertical-align: middle;
    margin-left: 10px;
}
.tableClass /deep/.el-table__header .cell {
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.el-button+.el-button {
  margin-left: 0;
}
 /deep/.el-table th, /deep/.el-table tr {
	  padding: 8px 5px  8px 5px !important;
}
/deep/.el-table th{
  background-color: #F5F6FA;
}

.abow_dialog {
  /deep/.el-dialog__body {
    overflow: auto;
  }
}

/deep/.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 0px solid #EBEEF5!important;
}
/deep/.el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 0px solid #EBEEF5;
}

</style>


// WEBPACK FOOTER //
// TableList.vue?71ade6df